// ----------------- START PURCHASE SCRIPT ------------------------------------

// `breeze-purchase` event listener
window.addEventListener("breeze-purchase", (event) => {
  const eventData = event.detail;
  breezePurchase(eventData);
});

// This function will be invoked by breeze after purchase
function breezePurchase(payload) {
  try {
    merchantPurchaseCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants purchase script : ", e);
  }
}

// merchant script for `purchase` will be pasted here
function merchantPurchaseCustomCode(params) {

  // GOOGLE ADS PURCHASE EVENT CODE START
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", "AW-11471996233");
  window.gtag("event", "purchase", {
    send_to: ["AW-11471996233/4aHCCJ6urKkZEMmKo94q"],
    value: params.totalPrice,
    currency: "INR",
    transaction_id: params.shopOrderId,
    triggered_by: "Breeze"
  });
  // GOOGLE ADS PURCHASE EVENT CODE END
  
}

// `breeze-begin-checkout` event listener
window.addEventListener("breeze-initiate-checkout", (event) => {
  const eventData = event.detail;
  breezeInitiateCheckout(eventData);
});
// This function will be invoked by breeze after begin checkout
function breezeInitiateCheckout(payload) {
  try {
    merchantInitiateCheckoutCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants initiate checkout script : ", e);
  }
}

function merchantInitiateCheckoutCustomCode(params) {
  // paste the snippet out here
    // GOOGLE ADS BEGIN CHECKOUT EVENT CODE START
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", "AW-11471996233");
  window.gtag("event", "begin_checkout", {
    send_to: ["AW-11471996233/eHMuCK2urKkZEMmKo94q"],
    value: params.totalPrice,
    currency: "INR",
    transaction_id: params.shopOrderId,
    triggered_by: "Breeze"
  });
  // GOOGLE ADS BEGIN CHECKOUT EVENT CODE END
}


// `breeze-add-payment-info` event listener
window.addEventListener("breeze-add-payment-info", (event) => {
  const eventData = event.detail;
  breezeAddPaymentInfo(eventData);
});
// This function will be invoked by breeze after add payment info
function breezeAddPaymentInfo(payload) {
  try {
    merchantAddPaymentInfoCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants add Payment info script : ", e);
  }
}

function merchantAddPaymentInfoCustomCode(params) {
  // paste the snippet out here
    // GOOGLE ADS ADD PAYMENT INFO EVENT CODE START
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", "AW-11471996233");
  window.gtag("event", "add_payment_info", {
    send_to: ["AW-11471996233/p6yQCLCurKkZEMmKo94q"],
    value: params.totalPrice,
    currency: "INR",
    transaction_id: params.shopOrderId,
    triggered_by: "Breeze"
  });
  // GOOGLE ADS ADD PAYMENT INFO EVENT CODE END
}

// ----------------- END PURCHASE SCRIPT --------------------------------------